import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress opaque cross-origin errors from the PayPal SDK's iframe teardown
// (zoid "destroyed all components" / "Script error.") so the CRA dev overlay
// doesn't block interaction. Production builds have no overlay.
const isPaypalNoise = (msg) =>
  /zoid|destroyed all components|Script error/i.test(String(msg || ""));
window.addEventListener("error", (e) => {
  if (isPaypalNoise(e.message)) e.stopImmediatePropagation();
}, true);
window.addEventListener("unhandledrejection", (e) => {
  const r = e.reason;
  if (isPaypalNoise((r && (r.message || r)) || "")) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
}, true);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
